export const mergeClasses = (...args) => args.filter(Boolean).join(' ');
